import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    redirect: '/home',
    component: () => import('@/views/home/home.vue')
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('@/views/home/home.vue')
  },
  {
    path: '/policy',
    name: 'policy',
    component: () => import('@/views/policy/policy.vue')
  },
  {
    path: '/forgot',
    name: 'forgot',
    component: () => import('@/views/forgot/forgot.vue')
  },
  {
    path: '/album',
    name: 'album',
    component: () => import('@/views/album/album.vue')
  },
  {
    path: '/album/info', // 保持嵌套的路径结构
    name: 'albumInfo',
    component: () => import('@/views/album/info.vue')
  },
  {
    path: '/trend',
    name: 'trend',
    component: () => import('@/views/trend/trend.vue')
  },
  {
    path: '/trend/info',
    name: 'trendInfo',
    component: () => import('@/views/trend/info.vue')
  },
  {
    path: '/trend/img',
    name: 'trendImg',
    component: () => import('@/views/trend/img.vue')
  },
  {
    path: '/generator',
    name: 'generator',
    component: () => import('@/views/generator/generator.vue'),
    children: [
      {
        // 子路由的 path 不需要加 '/'，最终路径是 /generator/imagine1
        path: 'imagine1',
        component: () => import('@/views/generator/imagine1.vue')
      },
      {
        path: 'imagine2',
        component: () => import('@/views/generator/imagine2.vue')
      },
      {
        path: 'imagine3',
        component: () => import('@/views/generator/imagine3.vue')
      },
      {
        path: 'imagine3a',
        component: () => import('@/views/generator/imagine3a.vue')
      },
      {
        path: 'blend',
        component: () => import('@/views/generator/blend.vue')
      },
      {
        path: 'extract',
        component: () => import('@/views/generator/extract.vue')
      },
      {
        path: 'square',
        component: () => import('@/views/generator/square.vue')
      },
      {
        path: 'describe',
        component: () => import('@/views/generator/describe.vue')
      },
      {
        path: 'cutout',
        component: () => import('@/views/generator/cutout.vue')
      },
      {
        path: 'upscale',
        component: () => import('@/views/generator/upscale.vue')
      },
      {
        path: 'model',
        component: () => import('@/views/generator/model.vue')
      }
    ]
  },
  {
    path: '/favorite',
    name: 'favorite',
    component: () => import('@/views/favorite/favorite.vue')
  }
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes
})

export default router
